import { ACHIEVEMENT_TIERS } from '@didaskill/domain/user-achievements/constants';
import { TAG_VARIANTS } from '@didaskill/ui/design-system';

export type TIERS_WITH_TAGS = Exclude<
  ACHIEVEMENT_TIERS,
  ACHIEVEMENT_TIERS.NEUTRAL | ACHIEVEMENT_TIERS.QUEST
>;

export const TIER_TAG_VARIANTS_MAP: Record<TIERS_WITH_TAGS, TAG_VARIANTS> = {
  [ACHIEVEMENT_TIERS.BRONZE]: TAG_VARIANTS.SECONDARY,
  [ACHIEVEMENT_TIERS.SILVER]: TAG_VARIANTS.TERTIARY,
  [ACHIEVEMENT_TIERS.GOLD]: TAG_VARIANTS.WARNING,
};
